module.exports = __webpack_public_path__ + "static/img/7.b993d25.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/9/sp/7.png
// module id = C0Nr
// module chunks = 0